export const SET_AUTH = 'SET_AUTH';
export const SET_PERFISPORTAL = 'SET_PERFISPORTAL';
export const SET_PERMISSAO = 'SET_PERMISSAO';
export const SET_MENU = 'SET_MENU';
export const SET_VALUEURLMANUAL = 'SET_VALUEURLMANUAL';
export const SET_VALUEPERFILTRIBUNAL = 'SET_VALUEPERFILTRIBUNAL';
export const SET_QTDAPROVACAO = 'SET_QTDAPROVACAO';
export const SET_TERMOACEITE = 'SET_TERMOACEITE';